var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 222,
    viewBox: "0 0 206 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5314 222C27.0503 220.312 19.9223 217.959 13.8863 212.846C2.15119 202.918 -2.82539 186.755 1.63504 172.128C6.36711 156.624 19.0204 146.245 34.8194 144.578C45.7395 143.429 55.22 146.757 64.5863 153.972V148.205C64.5863 112.205 64.5754 76.2001 64.5537 40.1894C64.5537 37.3849 64.733 35.5659 68.2318 34.6892C112.937 23.4928 157.618 12.1785 202.273 0.746127C203.359 0.468395 204.506 0.294069 206 0V4.03523C206 52.6219 206 101.209 206 149.795C206 166.214 199.051 178.69 184.306 186.44C160.983 198.698 131.33 182.154 128.776 155.9C126.603 133.741 142.902 113.619 166.595 112.879C174.594 112.622 182.459 114.989 188.995 119.621L192.798 122.278V59.0478C191.282 59.3474 189.804 59.5653 188.365 59.9301C153.181 68.8556 118.025 77.8737 82.8029 86.6141C78.6304 87.6543 77.4624 89.337 77.4895 93.5519C77.6851 122.327 77.5927 151.102 77.5873 179.877C77.5873 190.121 75.3489 199.596 68.5631 207.651C62.2664 215.144 54.4051 219.751 44.7616 221.325C44.2216 221.478 43.7018 221.696 43.2132 221.973L34.5314 222Z",
    fill: "#B9B9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioIcon);
export default __webpack_public_path__ + "static/media/audio-icon.8da058a6c5942a0c13a6f41c9699ed1e.svg";
export { ForwardRef as ReactComponent };